import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { useSnackbar } from 'notistack';
import { Grid, Paper, TextField, Button } from '@material-ui/core';
import MomentUtils from '@date-io/moment';
import EditIcon from '@material-ui/icons/Edit';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { assetTypeValues, backendDateFormat, fieldDateFormat } from '../../../constants';
import { numberWithCommas } from '../../../utils';
import { regexConstants } from '../../../constants/regEx';
import { globalGetService, globalPostService, globalPutService } from "../../../globalServices";
import { checkApiStatus, replaceEmptyNumber, checkPermission } from "../../utils_v2";
import { Skeleton } from "@material-ui/lab";
import { PageLoader } from "../../shared_elements";
import { getPermissionKey } from "..";
import { trackActivity } from "../../../utils/mixpanel";
import { halcyonInstance, hanwahaInstance, regionalOneInstance } from "../../../shared/components";

const UtilizationInfo = ({ params, assetInfoData, refreshKey ,onEditChange}) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [utilization, setUtilaization] = useState();
    const [utilizationsData, setUtilizationsData] = useState();
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [isEdit, setEdit] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [error, seterror] = useState({});
    useEffect(() => {
        getUtilizationsData('skeletonLoader')
    }, []);
    
    useEffect(() => {
        if (refreshKey) {
            getUtilizationsData('pageLoader')
        }
    }, [refreshKey]);

    const getUtilizationsData = (loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`console/v2/asset/${params?.type}/${params?.aircraft_slug}/utilization/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setUtilizationsData(response.data.data)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }
    const onEditUtilizationData = (loaderType) => {
        let validationInputs = {};
        validationInputs = {
            ...validationInputs,
            last_utilization_updated: utilizationsData.last_utilization_updated ? moment(utilizationsData.last_utilization_updated).isValid() && moment(utilizationsData.last_utilization_updated).isSameOrBefore(moment(), 'day') ? '' : "As of date can't be future Date" : 'Please enter As of Date',
            tsn: utilizationsData.tsn ? '': utilizationsData.tsn === 0 && !utilizationsData?.is_tsn_csn_updated ? 'Please enter TSN' : utilizationsData?.tsn.toString()?.trim()?.length ? '' : utilizationsData.tsn?? 'Please enter TSN',
            csn: utilizationsData.csn ? '': utilizationsData.csn ===0 && !utilizationsData?.is_tsn_csn_updated ? 'Please enter CSN'  : utilizationsData?.csn.toString()?.trim()?.length ? '' : utilizationsData.csn?? 'Please enter CSN'
        }
        if(utilizationsData.last_utilization_updated && !moment(utilizationsData.last_utilization_updated).isValid()){
            validationInputs = {
                ...validationInputs,
                last_utilization_updated:'Please enter valid As of Date'
            }
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
            if (utilizationsData) {
                globalPutService(`console/v2/asset/${params.type}/${params.aircraft_slug}/utilization/`, replaceEmptyNumber(utilizationsData, ['average_monthly_cycles', 'average_monthly_hours','egt_margin']))
                    .then(response => {
                        if (checkApiStatus(response)) {
                            setEdit(false); setLoading(false);onEditChange(false);
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
                            trackActivity('Console Management', { data:JSON.stringify(utilizationsData), page_title: 'Utlization Info', asset_type: assetTypeValues[assetInfoData?.asset_type.type].label, asset_name: assetInfoData?.serial_number, event_type: 'Item Edited', event_desc: 'Edited Utlization Info data from Edit Utlization Info form' });
                        }
                        loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
                    })
            }
        } else {
            seterror(validationInputs)
        }
    }
    const onFieldChange = (key, value) => {
        setUtilizationsData({ ...utilizationsData, [key]: value})
    }
    const onResetError = (key) => seterror({ ...error, [key]: '' })
    const displayValue = (value) => !isEdit && value !== '' && value !== null && value !== undefined ? numberWithCommas(value) : value;
    return (
        <Paper elevation={0} className="console-forms-fields console-paper" style={{ padding: '20px 10px', marginBottom: '15px', position: 'relative' }}>
            {checkPermission('technical_specs', getPermissionKey(params.type), 'U') && !isEdit ?
                <span className="edit-basic-info" style={{ top: "0px", right: "1px" }}>
                    <EditIcon onClick={() => {setEdit(true);onEditChange(true);}} fontSize="small" color='primary' />
                </span> : null
            }
            <Grid container spacing={1}>
                <Grid item md={4} lg={3}>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                            required
                            disabled={!isEdit}
                            margin="normal"
                            name="last_utilization_updated"
                            label="As of Date"
                            format={fieldDateFormat}
                            fullWidth
                            disableFuture
                            InputLabelProps={{ shrink: true }}
                            minDate={moment().subtract(25, 'years')}
                            value={utilizationsData?.last_utilization_updated || null}
                            onChange={(data, value) => { onFieldChange('last_utilization_updated', data ? moment(data).format(backendDateFormat) : null); onResetError('last_utilization_updated') }}
                            inputVariant='outlined'
                            error={error.last_utilization_updated ? true : false}
                            helperText={error.last_utilization_updated || ''}
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid item md={4} lg={2}>
                    <TextField
                        required
                        disabled={!isEdit}
                        name='tsn'
                        label='TSN'
                        value={displayValue(utilizationsData?.tsn || utilizationsData?.is_tsn_csn_updated? utilizationsData?.tsn ?? '': '')}
                        fullWidth
                        margin="normal"
                        inputProps={{ maxLength: 10 }}
                        onChange={(e) => regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('tsn', e.target.value) : e.preventDefault()}
                        InputLabelProps={{ shrink: true }}
                        variant='outlined'
                        error={error.tsn ? true : false}
                        helperText={error.tsn || ''}
                        onFocus={() => onResetError('tsn')}
                    />
                </Grid>
                <Grid item md={4} lg={2}>
                    <TextField
                        required
                        disabled={!isEdit}
                        name='csn'
                        label='CSN'
                        value={displayValue(utilizationsData?.csn || utilizationsData?.is_tsn_csn_updated? utilizationsData?.csn ?? '': '')}
                        fullWidth
                        inputProps={{ maxlength: 10 }}
                        margin="normal"
                        onChange={(e) => regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('csn', e.target.value) : e.preventDefault()}
                        InputLabelProps={{ shrink: true }}
                        variant='outlined'
                        error={error.csn ? true : false}
                        helperText={error.csn || ''}
                        onFocus={() => onResetError('csn')}
                    />
                </Grid>
                <Grid item md={4} lg={2}>
                    <TextField
                        disabled={!isEdit}
                        name='average_monthly_hours'
                        label='Avg. Monthly Hours'
                        value={displayValue(utilizationsData?.average_monthly_hours || '')}
                        fullWidth
                        inputProps={{ maxlength: 10 }}
                        margin="normal"
                        onChange={(e) => regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('average_monthly_hours', e.target.value) : e.preventDefault()}
                        InputLabelProps={{ shrink: true }}
                        variant='outlined'
                    />
                </Grid>
                <Grid item md={4}lg={3}>
                    <TextField
                        disabled={!isEdit}
                        name='average_monthly_cycles'
                        label='Avg. Monthly Cycles'
                        value={displayValue(utilizationsData?.average_monthly_cycles || '')}
                        fullWidth
                        margin="normal"
                        inputProps={{ maxlength: 10 }}
                        onChange={(e) => regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('average_monthly_cycles', e.target.value) : e.preventDefault()}
                        InputLabelProps={{ shrink: true }}
                        variant='outlined'
                    />
                </Grid>
                {hanwahaInstance || halcyonInstance?
                <Grid item md={4}lg={3}>
                    <TextField
                        disabled={!isEdit}
                        name='egt_margin'
                        label='EGT Margin'
                        value={utilizationsData?.egt_margin || ''}
                        fullWidth
                        margin="normal"
                        inputProps={{ maxlength:50}}
                        onChange={(e) =>  onFieldChange('egt_margin', e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        variant='outlined'
                    />
                </Grid>:null}
                {params?.type === "engine" && regionalOneInstance?
                <Grid item md={4}lg={3}>
                    <TextField
                        disabled={!isEdit}
                        name='egt_margin'
                        label='EGT Margin'
                        value={utilizationsData?.egt_margin || ''}
                        fullWidth
                        margin="normal"
                        inputProps={{ maxlength: 5}}
                        onChange={(e) => regexConstants.numberNoSpace.test(e.target.value) ? onFieldChange('egt_margin', e.target.value) : e.preventDefault()}
                        InputLabelProps={{ shrink: true }}
                        variant='outlined'
                    />
                </Grid>:null}
            </Grid>
            {isEdit ?
                <ul className="list-inline" style={{ paddingTop: '10px', textAlign: 'right' }}>
                    <li className="list-inline-item">
                        <Button onClick={() => { setEdit(false); getUtilizationsData('pageLoader'); seterror('');onEditChange(false); }} color="primary" size='small' variant="outlined">Cancel</Button>
                    </li>
                    <li className="list-inline-item">
                        <Button onClick={onEditUtilizationData} color="primary" size='small' variant="contained">SAVE</Button>
                    </li>
                </ul> : null
            }
            {isLoading ? <PageLoader /> : null}
        </Paper>
    )
}
export default withRouter(UtilizationInfo);